export const TWITTER_PREFILL = "twitter.com/";
export const LINKEDIN_PREFILL = "linkedin.com/company/";
